import { z } from 'zod'

/**
 * Nova Poshta express waybill numbers are 14 digits. Most current documents start with `20`,
 * but older and cargo numbers use other prefixes, so tracking accepts any 14-digit string.
 */
export const NOVA_POSHTA_TTN_LENGTH = 14
export const NOVA_POSHTA_TTN_PATTERN = /^\d{14}$/
/** Preferred prefix on current express waybills — used to rank OCR candidates, not to reject. */
export const NOVA_POSHTA_TTN_PREFIX = '20'

/** Below this, the UI should emphasize that the OCR draft needs careful review. */
export const TTN_AUTO_TRACK_CONFIDENCE = 0.8

/**
 * What the recognize endpoint accepts. It sniffs the actual bytes, so a wider `accept` on the
 * picker only lets a logistician choose a photo the API then refuses — both sides read these.
 */
export const TTN_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const
export const TTN_MAX_IMAGE_BYTES = 20 * 1024 * 1024

export const novaPoshtaTtnSchema = z
  .string()
  .trim()
  .regex(NOVA_POSHTA_TTN_PATTERN, 'Номер ТТН Нової Пошти має містити 14 цифр')

export type NovaPoshtaTtn = z.infer<typeof novaPoshtaTtnSchema>

export const novaPoshtaTrackingSchema = z.object({
  ttnNumber: novaPoshtaTtnSchema,
  found: z.boolean(),
  status: z.string(),
  statusCode: z.string().nullable(),
  citySender: z.string().nullable(),
  cityRecipient: z.string().nullable(),
  warehouseRecipient: z.string().nullable(),
  scheduledDeliveryDate: z.string().nullable(),
})

export type NovaPoshtaTracking = z.infer<typeof novaPoshtaTrackingSchema>

export const ttnRecognitionSchema = z.object({
  ttnNumber: z.string().nullable(),
  /** 0–1. Blurry photos land well below `TTN_AUTO_TRACK_CONFIDENCE`. */
  confidence: z.number().min(0).max(1),
  rawText: z.string(),
  needsConfirmation: z.boolean(),
  tracking: novaPoshtaTrackingSchema.nullable(),
})

export type TtnRecognition = z.infer<typeof ttnRecognitionSchema>
